<template>
	<div v-if="transparent">
		<slot />
	</div>
	<div v-else :class="$style['input-group']">
		<h4 v-if="label" :class="$style['input-group__label']">
			{{ label }}
		</h4>
		<div
			:class="[
				$style['input-group__content'],
				mobileBreak && $style['input-group__content--break']
			]"
		>
			<slot />
		</div>
	</div>
</template>
<script>
export default {
	name: 'InputGroup',
	props: {
		label: {
			type: String,
			default: null
		},
		transparent: {
			type: Boolean,
			default: false
		},
		mobileBreak: {
			type: Boolean,
			default: true
		}
	}
}
</script>
<style lang="scss" module>



	.input-group {
		display: flex;
		flex-flow: column;
		margin: 0 -#{$gutter * 1.25};

		&__label {
			margin: 0;
			padding: 0 $gutter * 1.25;
			font-weight: normal;
			font-size: 14px;
		}

		&__content {
			display: flex;
			align-items: flex-start;

			&--break {
				@include media-breakpoint-only(xs) {
					flex-flow: column;
				}
			}
			// padding-bottom: 10px;
		}
	}
</style>
